import { ThemeOptions } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

type Footer = {
    dsTitle: string;
    links: {
        dsTitle: string;
        dsLink: string;
        dsIcon?: string;
    }[];
};

export type Client = {
    name: string;
    clientId: string;
    logo: string;
    documentTitle: string;
    googleAnalyticsTrackingId: string;
    favicon: string[];
    theme: ThemeOptions;
    footer: Footer[];
    tipoPedido: 'padrao' | 'funcionario';
    fgAlteraEmpresa: boolean;
    fgExibeHelpDesk: boolean;
    fgDownloadRelatorioReport: boolean;
};

const SUBDOMAIN = window.location.hostname.split('.')[0];
const DEFAULT_SUBDOMAIN = 'portaldemonstracao';

/**
 * Busca o arquivo de configuração do host com base no subdomínio.
 */
const fetchHost = async (subdomain: string) => {
    const response = await fetch(`/config/${subdomain}/config.json`);

    if (!response.ok) {
        throw new Error(`Failed to fetch config for subdomain: ${subdomain}`);
    }

    return response.json();
};

export function useQueryApplicationClient() {
    return useQuery<Client>({
        queryKey: ['client', SUBDOMAIN],
        staleTime: Infinity,
        queryFn: async () => {
            try {
                return await fetchHost(SUBDOMAIN);
            } catch (err) {
                if (err instanceof Error && err.message.includes('is not valid JSON')) {
                    return fetchHost(DEFAULT_SUBDOMAIN);
                }

                throw err;
            }
        },
    });
}
